import { isFormTranslationsFeatureEnabled, user } from '@/ui/auth/auth';
import { LegacyChecklistRecord as Checklist } from '@/ui/pages/inspection/LegacyChecklistRecord';

export const isTranslationEnabled = (checklist: Checklist): boolean => isFormTranslationsFeatureEnabled.value
  && !!user.value.formTranslationsLocale
  && (checklist.fullTranslationLanguages || []).length > 0;
